import React from 'react';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { Box, Button } from '@mui/material';
import { useTranslation } from '@/src/i18n';
import { getCardFullName } from '@/components/utils';

import ContactFormDialog from '../ContactFormDialog/ContactFormDialog';

type Props = {
  card: CardHcd;
};

const PractitionerNoClient = ({ card }: Props) => {
  const { t } = useTranslation();
  const contactFormRef = React.useRef<any>();

  const isPharmacy =
    card?.type === 'CENTER' &&
    card?.center?.speciality?.shortName === 'pharmacie';

  const onClick = React.useCallback(() => {
    contactFormRef.current.showDialog();
  }, [contactFormRef]);

  return (
    <div id="rdv" className="bloc-prat-contact">
      <div className="wrapper">
        <div className="contact-title">
          <h4>
            <span>
              {t(
                isPharmacy
                  ? 'no-client-docavenue-pharmacy-appointment-form-title'
                  : 'no-client-docavenue-appointment-form-title',
                {
                  name: getCardFullName(t, card),
                },
              )}
            </span>

            <a href="#" className="link" onClick={onClick}>
              {t('modify_infos')}
            </a>
          </h4>
        </div>
        <div className="contact-content">
          <div>
            <p>{t('are_you_professional')}</p>
            <p>{t('discover_agenda_tlc_maiia')}</p>
            <Box mt={2}>
              <Button variant="contained" color="secondary" onClick={onClick}>
                {t('know_more')}
              </Button>
            </Box>
          </div>
        </div>
      </div>
      <ContactFormDialog ref={contactFormRef} />
    </div>
  );
};

export default PractitionerNoClient;
